import { Outlet } from 'react-router-dom';
import type { ReactNode } from 'react';
import { UiUsageRecorder } from '../lib/ui-usage';

/**
 * Shell for the setup wizard (`/member-onboarding`). It sits outside `Layout`, so
 * this mounts the page-view recorder over `wizardRoutes` the way `Layout` does over
 * `authenticatedRoutes`. Must render inside `AccountProvider`.
 */
export function WizardShell({ routes }: { routes: ReactNode }) {
  return (
    <>
      <UiUsageRecorder routes={routes} />
      <Outlet />
    </>
  );
}
